/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StaffOverviewEntryUserType
 */
export interface StaffOverviewEntryUserType {
    /**
     * 
     * @type {string}
     * @memberof StaffOverviewEntryUserType
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOverviewEntryUserType
     */
    title?: string;
}

/**
 * Check if a given object implements the StaffOverviewEntryUserType interface.
 */
export function instanceOfStaffOverviewEntryUserType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StaffOverviewEntryUserTypeFromJSON(json: any): StaffOverviewEntryUserType {
    return StaffOverviewEntryUserTypeFromJSONTyped(json, false);
}

export function StaffOverviewEntryUserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffOverviewEntryUserType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}

export function StaffOverviewEntryUserTypeToJSON(value?: StaffOverviewEntryUserType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'title': value.title,
    };
}

